type TagLike = { id: string; name: string };

/**
 * The tags to show for a line item: its own, then the ones it inherits from
 * its waste stream, each tag once and marked `inherited` when it is only on
 * the stream. Editing still works on `tags` alone.
 */
export function lineItemDisplayTags<T extends TagLike>(
  lineItem: { tags: readonly T[]; wasteStreamTags: readonly T[] } | null | undefined
): Array<T & { inherited: boolean }> {
  if (!lineItem) return [];
  const ownTagIds = new Set(lineItem.tags.map((tag) => tag.id));
  return [
    ...lineItem.tags.map((tag) => ({ ...tag, inherited: false })),
    ...lineItem.wasteStreamTags
      .filter((tag) => !ownTagIds.has(tag.id))
      .map((tag) => ({ ...tag, inherited: true })),
  ];
}
